/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type { GetReviewAverageByProductIdServerParams, ReviewAverageDTO } from '@as-react/common-types/review-service';
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import { queryFetch } from '../../utils/orval/queryFetch';
import type { ErrorType } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Finds the review average for the given product on the given webshop.
 */
export const getReviewAverageByProductIdServer = (
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName = 'getReviewAverageByProductId',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ReviewAverageDTO>(
    { url: `/public/review/average/v2/${productId}`, method: 'GET', params, signal },
    { operationName: 'getReviewAverageByProductId', ...options }
  );
};

export const getGetReviewAverageByProductIdServerQueryKey = (
  productId: number,
  params?: GetReviewAverageByProductIdServerParams,
  operationName = 'getReviewAverageByProductId'
) => queryKeyMutator({ productId, params, operationName }, { url: `/public/review/average/v2/${productId}` });

export const useGetReviewAverageByProductIdServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
  TError = ErrorType<ReviewAverageDTO>,
>(
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName = 'getReviewAverageByProductId',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { productId, params, operationName },
    { url: `/public/review/average/v2/${productId}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>> = ({ signal }) =>
    getReviewAverageByProductIdServer(productId, params, operationName, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: productId !== null && productId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetReviewAverageByProductIdServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>
>;
export type GetReviewAverageByProductIdServerQueryError = ErrorType<ReviewAverageDTO>;

export function useGetReviewAverageByProductIdServer<
  TData = Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
  TError = ErrorType<ReviewAverageDTO>,
>(
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
          TError,
          Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReviewAverageByProductIdServer<
  TData = Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
  TError = ErrorType<ReviewAverageDTO>,
>(
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
          TError,
          Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReviewAverageByProductIdServer<
  TData = Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
  TError = ErrorType<ReviewAverageDTO>,
>(
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Finds the review average for the given product on the given webshop.
 */

export function useGetReviewAverageByProductIdServer<
  TData = Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>,
  TError = ErrorType<ReviewAverageDTO>,
>(
  productId: number,
  params: GetReviewAverageByProductIdServerParams,
  operationName = 'getReviewAverageByProductId',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReviewAverageByProductIdServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReviewAverageByProductIdServerQueryOptions(productId, params, operationName, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
